// Mantendo as interfaces antigas para compatibilidade com os componentes de gráfico
export interface SingleValueData {
  name: string;
  value: number;
}

export interface ComparativeData {
  previous_month: number;
  two_months_ago: number;
}

export interface ProcedureRanking {
  name: string;
  value: number;
}

export interface PatientComparison {
  new_patients: number;
  recurring_patients: number;
}

export interface PatientMonthComparison {
  previous_month: PatientComparison;
  two_months_ago: PatientComparison;
}

export interface GeneratedVsCompletedComparison {
  generated: number;
  signed: number;
}

export interface MonthlyGeneratedVsCompletedComparison {
  previous_month: GeneratedVsCompletedComparison;
  two_months_ago: GeneratedVsCompletedComparison;
}

export interface StatusData {
  total: number;
  answered: number;
  pending: number;
}

export interface DashboardData {
  avgTicketComparison: ComparativeData;
  totalRevenueComparison: ComparativeData;
  proceduresRanking: ProcedureRanking[];
  newVsRecurringPatients: PatientMonthComparison;
  avgReturnTime: ComparativeData;
  contractsGeneratedVsSigned: MonthlyGeneratedVsCompletedComparison;
  anamnesesGeneratedVsFilled: MonthlyGeneratedVsCompletedComparison;
  avgPatientAge: ComparativeData;
  currentMonthPatientCount: StatusData;
  contractsStatus: StatusData;
  anamnesesStatus: StatusData;
  patientTotalData: StatusData;
}

// Novas interfaces para o dashboard reestruturado
export interface FilteredDashboardData {
  average_ticket: number;
  total_revenue: number;
  total_patients: number;
  total_sent_anamnesis: number;
  total_documents: number;
  total_signed_documents: number;
  total_pending_documents: number;
  total_pending_by_patient_documents: number;
  total_pending_by_responsible_documents: number;
  total_refund_amount: number;
  total_refund_count: number;
  net_revenue: number;
  origin_ranking: [string, number][];
  procedure_ranking: ProcedureRanking[];
}

export interface GeneralDashboardData {
  total_revenue_history: [string, number][];
  average_ticket_history: [string, number][];
  average_patient_age: number;
}

export interface DocumentCountsDto {
  total_documents: number;
  total_signed: number;
  total_pending: number;
  total_signed_only_by_responsible: number;
  total_signed_only_by_client: number;
}

export interface RankingItemDto {
  name: string;
  value: number;
}

/** @deprecated Use separate endpoint responses instead */
export interface NewDashboardResponse {
  filtered_data: FilteredDashboardData;
  general_data: GeneralDashboardData;
}

// Filtros do dashboard
export interface DashboardFilters {
  clinic_id: string;
  initial_date: string;
  final_date: string;
  responsible_id?: string;
  // Quando não for usuário ROOT, enviar o módulo selecionado
  module?: string;
}

// Opções de período
export enum PeriodFilter {
  FIFTEEN_DAYS = 'd-14',
  SIXTY_DAYS = 'd-60',
  THREE_MONTHS = 'm-3',
  SIX_MONTHS = 'm-6',
  TWELVE_MONTHS = 'm-12',
  CUSTOM = 'custom'
} 